import { NotFound } from '@app/NotFound/NotFound';
import React, { useState } from 'react';

interface IframeWithErrorHandlingProps {
  src: string;
  title: string;
  width?: string;
  height?: string;
}

const IframeWithErrorHandling: React.FC<IframeWithErrorHandlingProps> = ({
  src,
  title,
  width = '100%',
  height = '100%',
}) => {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
  };

  return (
    <div style={{ width, height }}>
      {hasError ? (
        <NotFound />
      ) : (
        <iframe
          src={src}
          title={title}
          width={width}
          height={height}
          onError={handleError}
          style={{
            border: 'none',
            display: 'block',
            margin: 0,
            padding: 0
          }}
        />
      )}
    </div>
  );
};

export { IframeWithErrorHandling };
